import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-advent-of-code',
    templateUrl: './advent-of-code.component.html',
    styleUrls: ['./advent-of-code.component.css', '../blog.css'],
})
export class AdventOfCodeComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}



// WEBPACK FOOTER //
// /Users/masonpimentel/Repos/mason-blog/src/app/advent-of-code/advent-of-code.component.ts